function PageHeader({ eyebrow, title, intro, children }) {
  return (
    <header className="pa-page-head">
      {eyebrow && <p className="pa-eyebrow">{eyebrow}</p>}
      <h1 className="pa-page-head__title">{title}</h1>
      {intro && <p className="pa-page-head__intro prose">{intro}</p>}
      {children}
    </header>
  );
}

export default PageHeader;
